import { Files } from '../../../lib/constants/files'
import { CenterTeflCostInvoiceInput } from '../../../lib/types/models/center/center-tefl-cost'
import { uploadFile } from '../../../lib/utils/functions/file.functions'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export async function uploadCenterTeflCostsInvoice(
  id: number,
  teflCostId: number,
  data: CenterTeflCostInvoiceInput
) {
  const uploadedFile = await uploadFile(Files.CENTER_TEFL_COSTS_INVOICE, data.file)
  if (uploadedFile) data.file = uploadedFile
  else throw new Error('File not uploaded')

  return restApiClient
    .url(constructApiUrl(API.centers.uploadCenterTeflCostInvoice.url, { id, teflCostId }))
    .post(data)
}
